// extracted by mini-css-extract-plugin
export var spinner = "Q7_8q";